import Paragraph from 'structure/launchpad/components/Typography';
import React from 'react';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { Icons } from '@dapp/multi-lib/ui/icons';

export function ActionSteps({
  approve,
  deposit,
}: {
  approve: boolean;
  deposit: boolean;
}) {
  const { t } = useTranslation('common');
  return (
    <div className='flex flex-row gap-3'>
      <Paragraph
        className={twMerge(cx('text-xs', { 'text-[#B4BCD0]': !approve }))}
      >
        1. {t('STAKING.APPROVE')}
      </Paragraph>
      <Icons
        icon='arrow_right_long'
        iconHeight='13'
        iconWidth='23'
        viewboxHeight={12}
        viewboxWidth={24}
        fillColor='#F7F8F8'
      />
      <Paragraph
        className={twMerge(cx('text-xs', { 'text-[#B4BCD0]': !deposit }))}
      >
        2. {t('STAKING.DEPOSIT')}
      </Paragraph>
    </div>
  );
}
